<template>
  <div class="rhg-text-list-with-title">
    <typography v-if="title" :tag="'h3'" size="sm">
      <i :class="`rhg-font-icon--${icon}`" class="sm"></i> {{ title }}
    </typography>
    <typography :tag="'p'" v-for="(item, key) in items" :key="key" size="md">
      <span v-if="item.start && item.end">{{ item.start }} {{ item.preposition }} {{ item.end }}: </span>
      <span v-if="!item.startRange && item.endRange && item.startRange && item.endRange">{{ item.startRange }} {{ item.preposition }} {{ item.endRange }} | </span>
      <span class="rhg-text-list-with-title-hour" v-if="item.startHour">{{ item.startHour | formatHour(item.startMinute) }}</span>
      <span v-if="item.startHour && item.startMinute">:{{ item.startMinute | formatMinutes(item.startHour) }}</span>
      <span class="rhg-text-list-with-title-hour" v-if="item.endHour"> - {{ item.endHour | formatHour(item.endMinute) }}</span>
      <span v-if="item.endHour && item.endMinute">:{{ item.endMinute | formatMinutes(item.endHour) }}</span>
    </typography>
  </div>
</template>

<script>
import Typography from '../../../Atoms/typography/Typography.vue'
export default {
  name: 'TextListWithTitle',
  components: { Typography },
  props: {
    icon: {
      type: String,
      default: 'time'
    },
    title: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  }

}
</script>

<style lang="scss">
.rhg-text-list-with-title {
  i {
    margin-right: 0.5rem;
  }
  p, h3 {
    margin: 1rem 0 0 ;
  }
}

.rhg-text-list-with-title-two{
  width: 100%;
  border-left: unset;
  @media (min-width: 992px) {
    width: 50%;
  }
  p{
    width: max-content;
  }
}

html[dir="rtl"] {
  .rhg-text-list-with-title {
    i {
      margin-right: 0;
      margin-left: 0.5rem;
    }
    h2, p {
      text-align: initial;
    }
  }
}
</style>
